import React from "react";
import Routing from "./Routes/Routing";

// Store and providers
import store from "./Redux/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "./contexts/ThemeContext";
import { MapProvider } from "./contexts/ClustererContext";

import { registerLicense } from "@syncfusion/ej2-base";

// Styles
import "./styles/themes.css";
import { SelectedProvider } from "./contexts/SelectedContext";

registerLicense(process.env.REACT_APP_SYNCFUSION_SECRET);

function App() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <ThemeProvider>
          <SelectedProvider>
            <MapProvider>
                <Routing />
            </MapProvider>
          </SelectedProvider>
        </ThemeProvider>
      </Provider>
    </React.Fragment>
  );
}

export default App;
